
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-analytical-data-readonly',
    imports: [],
    templateUrl: './analytical-data-readonly.component.html',
    styleUrl: './analytical-data-readonly.component.scss'
})
export class AnalyticalDataReadonlyComponent {

  @Input() analyticalData: any = null;

}
